import { createGlobalStyle } from 'styled-components';

const assumedBrowserDefaultFontSize = 16;

const GlobalStyle = createGlobalStyle`
    html {
        font-family: "Roboto", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif ;
        font-size: ${(16 / assumedBrowserDefaultFontSize) * 100}%;
        font-weight: 300;
        scroll-behavior: smooth;
    }
    h1 {
        font-weight: 900;
    }
    h2 {
        font-weight: 900;
    }
    *, *::before, *::after {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    /* Remove visible outline for non-keyboard users */
    :focus:not(:focus-visible) { outline: none }

    html {-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;}
    body { 
        font-weight: 300;
        font-family: "Roboto", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
        color: #393939;
        margin: 0px;
        overflow-x: clip !important;
        -moz-scrollbars-none 
        overflow: clip;
        -webkit-overflow-x: clip;
        -webkit-overflow: clip;

    }

    /*
        ******** layout *******************
    *, *::before, *::after {-webkit-box-sizing: inherit;  -moz-box-sizing: inherit;  box-sizing: inherit;  }
    */

   .ReactModal__Overlay.ReactModal__Overlay--after-open { z-index: 15;}
`;

export default GlobalStyle;
